import { ButtonSecondary } from 'fukku/Button/Secondary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import style from './AddBankDataButton.module.scss'

interface AddBankDataButtonProps {
	readonly handleOpenBankDataModal: () => void
}

export function AddBankDataButton({
	handleOpenBankDataModal,
}: AddBankDataButtonProps) {
	const { t } = useLabels()

	return (
		<ButtonSecondary
			data-testid='myRefunds.bankDetails.add.button'
			onClick={handleOpenBankDataModal}
			className={style.addBankDetailsBtn}
		>
			{t('myRefunds.bankDetails.add.button')}
		</ButtonSecondary>
	)
}
